import GUI from 'lil-gui';

export default class ControlsPredict {

    constructor(GAME) {

        this.gui = new GUI();

        this.environmentFolder = this.gui.addFolder('Environment');
        this.environmentFolder.add(GAME.config.wind, 'intensity').name('Wind intensity').min(0).max(1).step(0.1);
        this.environmentFolder.add(GAME.config.ball, 'launch_strength').name('Launch strength').min(0).max(GAME.config.ball.max_launch_strength).step(0.1);


        // -----------------------------
        // 🕓 Time
        // -----------------------------
        this.timeFolder = this.gui.addFolder('Time');
        this.timeFolder.add(GAME.TIME, 'pause').name('Pause');
        this.timeFolder.add(GAME.TIME, 'resume').name('Resume');

        // -----------------------------
        // 🎲 Game
        // -----------------------------
        this.gameFolder = this.gui.addFolder('Game');
        this.gameFolder.add(GAME.BALL.mesh.scene.position, 'x').min(-0.2).max(0.2).step(0.001);
        this.gameFolder.add(GAME.BALL.mesh.scene.position, 'y').min(-0.2).max(0.2).step(0.001);
        this.gameFolder.add(GAME.BALL.mesh.scene.position, 'z').min(-0.2).max(0.2).step(0.001);

        if (window.innerWidth < 768) this.gui.close();



    }
}